var map = {
	"./StarRocks.jpg": "15c9",
	"./TiDB.jpg": "7e7e",
	"./api.jpg": "6817",
	"./ck.jpg": "a7fc",
	"./db2.jpg": "87b2",
	"./ds_doris.jpg": "5057",
	"./es.jpg": "a13c",
	"./hive.jpg": "d225",
	"./impala.jpg": "7144",
	"./mariadb.jpg": "35e18",
	"./mongo.jpg": "5a73",
	"./mysql.jpg": "b9767",
	"./oracle.jpg": "6df3",
	"./pg.jpg": "8e65",
	"./redshift.jpg": "a8c0",
	"./sqlServer.jpg": "3fb1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2783";